var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[(_vm.switch_tab == 'list')?_c('List',{on:{"tab":(value) => {
      _vm.selectTab(value);
    }}}):_vm._e(),(_vm.switch_tab == 'contacts')?_c('Contacts',{on:{"tab":(value) => {
      _vm.selectTab(value);
    }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }